import { FC } from 'react';

import {
  useCustomerStore,
  useRegistrationStore,
} from 'page/NotificationPage/hooks';
import { ConfirmationModalView } from 'page/NotificationPage/components/ConfirmationModalView';

type Props = {
  handleClose: () => void;
  handleClickGoFirst: () => void;
  handleClickRegistration: () => void;
};

export const ConfirmationModal: FC<Props> = ({
  handleClose,
  handleClickGoFirst,
  handleClickRegistration,
}) => {
  const {
    isOpenSecondModal,
    title,
    message,
    isHigh,
    startDate,
    endDate,
    conditionForDisplay,
    shouldShowCustomerList,
  } = useRegistrationStore();
  const { selectedCustomers, selectedCustomersLength } = useCustomerStore();

  return (
    <>
      {/* 確認モーダル */}
      <ConfirmationModalView
        mode="新規作成"
        isOpen={isOpenSecondModal}
        title={title}
        message={message}
        isHigh={isHigh}
        startDate={startDate}
        endDate={endDate}
        conditionForDisplay={conditionForDisplay}
        shouldShowCustomerList={shouldShowCustomerList}
        selectedCustomers={selectedCustomers}
        selectedCustomersLength={selectedCustomersLength}
        handleClose={handleClose}
        handleClickGoInput={handleClickGoFirst}
        handleClickExecution={handleClickRegistration}
      />
    </>
  );
};
